import React, { PureComponent } from 'react';
import Spinner from 'react-spinkit';
import styled from 'styled-components';
import ReportComponent from './ReportComponent';

const ReportTabAreaContainer = styled.div`
  grid-column: 1;
  grid-row: 1;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 48px 16px;
  box-sizing: border-box;
  padding: 1vw 6vw;
  min-width: 0;
  min-height: 0;
  display: ${props => (props.isActive ? 'grid' : 'none')};
  ${props =>
    props.presentable
      ? `overflow: auto;`
      : `position: relative; overflow: hidden;`};
`;

const ReportTabAreaSpacer = styled.div`
  grid-column: span 12;
  height: 1px;
`;

const ReportTabAreaTitle = styled.h1`
  grid-column: span 12;
  font-size: 25px;
  color: #42515a;
`;

const ReportTabAreaSpinner = styled.div`
  display: ${props => (props.visible ? 'grid' : 'none')};
  align-items: center;
  justify-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: white;
  color: black;
  text-align: center;
  z-index: 1;
`;

class ReportTabArea extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      componentsToLoad: props.reportTabItem.components.length
    };
    this.componentLoaded = this.componentLoaded.bind(this);
  }

  componentLoaded() {
    this.setState(state => ({
      componentsToLoad: state.componentsToLoad - 1
    }));
  }

  render() {
    const {
      reportName,
      reportPageName,
      reportTabName,
      reportVersionString,
      reportLastUpdated
    } = this.props;

    return (
      <ReportTabAreaContainer
        isActive={this.props.isActive}
        presentable={this.state.componentsToLoad === 0}
      >
        <ReportTabAreaSpacer />
        <ReportTabAreaSpinner visible={this.state.componentsToLoad !== 0}>
          <Spinner name="ball-grid-pulse" color="#2cc4f4" />
        </ReportTabAreaSpinner>
        <ReportTabAreaTitle>
          {reportName} - {reportPageName}
          {reportPageName === reportTabName ? '' : ' - ' + reportTabName}
        </ReportTabAreaTitle>
        {this.props.reportTabItem.components.map(
          ({ id, data_type, columns, height_in_px }) => (
            <ReportComponent
              key={id}
              onComponentLoad={this.componentLoaded}
              reportComponentId={id}
              reportVersionString={reportVersionString}
              reportLastUpdated={reportLastUpdated}
              reportComponentDataType={data_type}
              reportComponentColumns={columns}
              reportComponentHeightInPx={height_in_px}
              apiEndpoint={this.props.apiEndpoint}
              isActive={this.props.isActive}
            />
          )
        )}
        <ReportTabAreaSpacer />
      </ReportTabAreaContainer>
    );
  }
}

export default ReportTabArea;
